
import { defineComponent, ref, watchEffect, computed } from "vue";
import { useStore } from "vuex";
import { Field, ErrorMessage } from "vee-validate";
import Editor from "@tinymce/tinymce-vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep1 {
  p1: string;
  p2: string;
  p3: string;
  p4: string;
  p5: string;
  p6: string;
  p7: string;
  p8: string;
  p9: string;
  p10: string;
  p11: string;
  p12: string;
  p13: string;
  p14: string;
  p15: string;
  p16: string;
  p17: string;
  p18: string;
  p19: string;
  p20: string;
  otherInvolvedResearch: string;
  degreeOfRisks: string;
  precautions: string;
  riskInTerms: string;
}

export default defineComponent({
  name: "step-1",
  components: {
    Field,
    ErrorMessage,
    Editor,
    DropDownSection,
  },
  setup() {
    const store = useStore();

    const step1 = ref<IStep1>({
      p1: "0",
      p2: "0",
      p3: "0",
      p4: "0",
      p5: "0",
      p6: "0",
      p7: "0",
      p8: "0",
      p9: "0",
      p10: "0",
      p11: "0",
      p12: "0",
      p13: "0",
      p14: "0",
      p15: "0",
      p16: "0",
      p17: "0",
      p18: "0",
      p19: "0",
      p20: "0",
      otherInvolvedResearch: "",
      degreeOfRisks: "",
      precautions: "",
      riskInTerms: "",
    });

    const submitButtonRef = ref<null | HTMLButtonElement>(null);

    const submit = () => {
      console.log("dsadsa");
      if (!submitButtonRef.value) {
        return;
      }
    };

    watchEffect(() => {
      const data = store.getters.currentRisk;
      if (data === null || data.data === undefined) return;
      step1.value.p1 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 1 &&
        data.data.involvedResearch[1].isChecked
          ? "1"
          : "0";
      step1.value.p2 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 2 &&
        data.data.involvedResearch[2].isChecked
          ? "1"
          : "0";
      step1.value.p3 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 3 &&
        data.data.involvedResearch[3].isChecked
          ? "1"
          : "0";
      step1.value.p4 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 4 &&
        data.data.involvedResearch[4].isChecked
          ? "1"
          : "0";
      step1.value.p5 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 5 &&
        data.data.involvedResearch[5].isChecked
          ? "1"
          : "0";
      step1.value.p6 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 6 &&
        data.data.involvedResearch[6].isChecked
          ? "1"
          : "0";
      step1.value.p7 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 7 &&
        data.data.involvedResearch[7].isChecked
          ? "1"
          : "0";
      step1.value.p8 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 8 &&
        data.data.involvedResearch[8].isChecked
          ? "1"
          : "0";
      step1.value.p9 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 9 &&
        data.data.involvedResearch[9].isChecked
          ? "1"
          : "0";
      step1.value.p10 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 10 &&
        data.data.involvedResearch[10].isChecked
          ? "1"
          : "0";
      step1.value.p11 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 11 &&
        data.data.involvedResearch[11].isChecked
          ? "1"
          : "0";
      step1.value.p12 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 12 &&
        data.data.involvedResearch[12].isChecked
          ? "1"
          : "0";
      step1.value.p13 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 13 &&
        data.data.involvedResearch[13].isChecked
          ? "1"
          : "0";
      step1.value.p14 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 14 &&
        data.data.involvedResearch[14].isChecked
          ? "1"
          : "0";
      step1.value.p15 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 15 &&
        data.data.involvedResearch[15].isChecked
          ? "1"
          : "0";
      step1.value.p16 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 16 &&
        data.data.involvedResearch[16].isChecked
          ? "1"
          : "0";
      step1.value.p17 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 17 &&
        data.data.involvedResearch[17].isChecked
          ? "1"
          : "0";
      step1.value.p18 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 18 &&
        data.data.involvedResearch[18].isChecked
          ? "1"
          : "0";
      step1.value.p19 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 19 &&
        data.data.involvedResearch[19].isChecked
          ? "1"
          : "0";
      step1.value.p20 =
        data.data.involvedResearch != null &&
        data.data.involvedResearch.length > 20 &&
        data.data.involvedResearch[20].isChecked
          ? "1"
          : "0";
      step1.value.otherInvolvedResearch = data.data.otherInvolvedResearch || "";
      step1.value.degreeOfRisks = data.data.degreeOfRisks || "";
      step1.value.precautions = data.data.precautions || "";
      step1.value.riskInTerms = data.data.riskInTerms || "";
    });

    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    const listDropDownSections = [
      {
        title: "Information about Risk Factors",
        descriptions: [
          {
            description:
              " A research subject is considered to be at risk if he or she may be exposed through " +
              " the procedures of the proposed research study to the possibility of physical or mental harm, " +
              " coercion, deceit or loss of privacy. Placing subjects at risk of harm could include: ",
          },
          { description: "(a) administration of unusual physical exertion," },
          { description: "(b) deceit," },
          { description: "(c) public disclosure of private information," },
          { description: "(d) embarrassment or humiliation," },
          { description: "(e) mental anguish. " },
        ],
      },
    ];

    return {
      submit,
      submitButtonRef,
      step1,
      Editor,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
